import numeral from 'numeral';

export default function () {
    numeral.register("locale", "sv-se", {
        delimiters: {
            thousands: "",
            decimal: ","
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "kr"
        }
    })
}